import axios from "axios";
import { API_BASE } from "../config/constants";

export const authorizationResource = axios.create({
  baseURL: `${API_BASE}/api/v1/authorization`,
  headers: {
    "Content-Type": "application/json",
  },
});

export const currentUserResource = axios.create({
  baseURL: `${API_BASE}/api/v1/currentUser`,
});

export const paymentResource = axios.create({
  baseURL: `${API_BASE}/api/v1/payment`,
  headers: {
    "Content-Type": "application/json",
  },
});

export const pricingResource = axios.create({
  baseURL: `${API_BASE}/api/v1/prices`,
  headers: {
    "Content-Type": "application/json",
  },
});

export const pricingTableResource = axios.create({
  baseURL: `${API_BASE}/api/v1/pricing-table?excludeFields=viewGroupsIds,viewUsersIds,editGroupsIds,editUsersIds,docPermissions,_edit,_publish,_originalWidgets,published,createdAt,updatedAt,titleSortified,highSearchText,highSearchWords,lowSearchText,searchSummary,_viaOrdering`,
  headers: {
    "Content-Type": "application/json",
    Authorization: "ApiKey 94f02c44-84eb-48dd-b371-ba8b2514aa42",
  },
});

export const registrationResource = axios.create({
  baseURL: `${API_BASE}/api/v1/registrations`,
  headers: {
    "Content-Type": "application/json",
    Authorization: "ApiKey 58c02f1b-b9e5-49b0-af91-7d86ef036292",
  },
});

export const attachmentResource = axios.create({
  baseURL: `${API_BASE}/api/v1/attachments`,
  headers: {
    "Content-Type": "multipart/form-data",
    Authorization: "ApiKey 1d952c05-474f-4006-978b-c4d871d9ae4f",
  },
});

export const pageTypeResource = axios.create({
  baseURL: `${API_BASE}/api/v1/pageType`,
  headers: {
    "Content-Type": "application/json",
  },
});

export const verificationResource = axios.create({
  baseURL: `${API_BASE}/api/v1/mcaptcha`,
  headers: {
    Authorization: "ApiKey 4c121cf9-4a79-4749-bcc2-c2bf5efe9d12",
  },
});

export const mcaptchaSettingsResource = axios.create({
  baseURL: `${API_BASE}/api/v1/mcaptcha/settings`,
});

export const registerUserResource = axios.create({
  baseURL: `${API_BASE}/api/v1/users/register`,
  headers: {
    Authorization: "ApiKey 4c121cf9-4a79-4749-bcc2-c2bf5efe9d12",
  },
});

export const rockbowlRegistrationResource = axios.create({
  baseURL: `${API_BASE}/api/v1/rockbowl-registrations`,
  headers: {
    "Content-Type": "application/json",
    Authorization: "ApiKey 58c02f1b-b9e5-49b0-af91-7d86ef036292",
  },
});

export const rockbowlRegistrationMailResource = axios.create({
  baseURL: `${API_BASE}/api/v1/rockbowl/registration/mail`,
  headers: {
    "Content-Type": "application/json",
  },
});
